// Vietnamese e-invoice XML (TCT schema, PBan 2.1.0 / TT78) → payment line
// fields. Same `HDon > DLHDon > TTChung / NDHDon` layout across providers;
// some files wrap it in a tax-authority message (`TDiep > DLieu > HDon`), so
// HDon is looked up anywhere. Paths walk direct children only — `NBan` also
// appears under the signature block (DSCKS), which must not be picked up.

const child = (el, name) => (el ? Array.from(el.children).find((c) => c.localName === name) || null : null)

const textAt = (el, ...path) => {
  const node = path.reduce((cur, name) => child(cur, name), el)
  return node?.textContent?.trim() || ""
}

export const parseInvoiceXml = (xmlText) => {
  const doc = new DOMParser().parseFromString(xmlText, "application/xml")
  if (doc.getElementsByTagName("parsererror").length) throw new Error("File XML không hợp lệ.")
  const hdon = doc.getElementsByTagName("HDon")[0]
  const dl = child(hdon, "DLHDon")
  if (!dl) throw new Error("Không phải file XML hoá đơn điện tử (thiếu HDon/DLHDon).")

  const info = child(dl, "TTChung")
  const content = child(dl, "NDHDon")
  const seller = child(content, "NBan")
  const items = Array.from(child(content, "DSHHDVu")?.children || [])
    .map((it) => textAt(it, "THHDVu"))
    .filter(Boolean)

  const amount = Number(textAt(content, "TToan", "TgTTTBSo"))
  return {
    invoiceSerial: `${textAt(info, "KHMSHDon")}${textAt(info, "KHHDon")}`,
    invoiceNumber: textAt(info, "SHDon"),
    invoiceDate: textAt(info, "NLap"),
    amount: Number.isFinite(amount) && amount > 0 ? amount : null,
    supplierTaxCode: textAt(seller, "MST"),
    sellerName: textAt(seller, "Ten"),
    bankAccount: textAt(seller, "STKNHang"),
    // Non-standard but seen in the wild (e.g. Central Retail puts it here).
    bankNameBranch: textAt(seller, "TNHang") || textAt(hdon, "TSDNode", "NBan_TNHang"),
    items,
  }
}
